import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'
import { IncomeBadge, MissedBadge, PaidBadge, UpcomingExpenseBadge } from '../RecurrenceBadges'
import { useGlobalCopyStore } from '../../../common'

interface SymbolProps {
  icon: any
  label: string
}

const Symbol = ({ icon: Icon, label }: SymbolProps) => (
  <Stack alignItems="center" flexDirection="row" sx={{ gap: 6 }}>
    <Icon />
    <Text variant="caption">{label}</Text>
  </Stack>
)

export const Legend = observer(() => {
  const { recurring: copy } = useGlobalCopyStore()

  return (
    <Stack
      alignItems="center"
      aria-hidden={true}
      flexDirection="row"
      gap={16}
      justifyContent="center"
      mt={12}
    >
      <Symbol icon={UpcomingExpenseBadge} label={copy.expense} />
      <Symbol icon={IncomeBadge} label={copy.income} />
      <Symbol icon={MissedBadge} label={copy.missed} />
      <Symbol icon={PaidBadge} label={copy.paid} />
    </Stack>
  )
})
